import useOutsideClick from "hooks/click-outside";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";

interface CancelSubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDisableAutoRenew: () => void;
  onCancelNow: () => void;
}

const CancelSubscriptionModal: React.FC<CancelSubscriptionModalProps> = ({
  isOpen,
  onClose,
  onDisableAutoRenew,
  onCancelNow,
}) => {
  const modalRef = useOutsideClick(onClose);
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[90%] sm:w-[380px] h-auto transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-3 text-gray-800">
          Cancel Subscription
        </h2>

        <p className="text-gray-600 leading-relaxed mb-6">
          {/* You can either cancel your subscription immediately, or choose to keep
          it active until the current billing period ends. <br />
          <br /> */}
          <b>Disable Auto-Renew</b> will stop future renewals but keep your
          benefits active until the period ends. <br />
          {/* <b>Cancel Now</b> will immediately end your subscription and all
          remaining benefits. */}
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onDisableAutoRenew}
            className="px-4 py-2 rounded-full bg-gray-300 text-gray-800"
          >
            Disable Auto-Renew
          </button>

          {/* <button
            onClick={onCancelNow}
            className="px-4 py-2 rounded-full bg-red-500 text-white"
          >
            Cancel Now
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
